"use strict";
/**
 * User Domain Types
 *
 * Frontend-optimized types for React components
 * Based on actual frontend usage analysis
 */
Object.defineProperty(exports, "__esModule", { value: true });
